module.exports = __webpack_public_path__ + "static/apple-touch-icon-b05abaac039cf6fbf8b7b23b20fcfa27.png";